// Element that we are watching
const elementNode = document.querySelector('.related-products');
const recentNode = document.querySelector('.pp-carousel-recent');

const observer = new MutationObserver((mutationsList, observer) => {  
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && window.innerWidth > 1024) {
            let relatedCarousel = document.querySelector('.pp-carousel-related');
            if (relatedCarousel) {
                let flkty = new Flickity(relatedCarousel, {
                freeScroll: true,
                wrapAround: true,
                prevNextButtons: true,
                pageDots: false,
                cellAlign: 'left',
                });
                observer.disconnect();
            }
        }
    }
});

observer.observe(elementNode, {
    attributes: false,
    childList: true,
    subtree: false,
});

const recentObserver = new MutationObserver((mutationsLists, recentObserver) => {  
    for (const mutation of mutationsLists) {
        if (mutation.type === 'childList' && window.innerWidth > 1024) {
            let recentCarousel = document.querySelector('.pp-carousel-recent');
            if (recentCarousel) {
                let flkty = new Flickity(recentCarousel, {
                    wrapAround: false,
                    prevNextButtons: true,
                    pageDots: false,
                    contain: true,
                    cellAlign: 'left',
                });
                recentObserver.disconnect();
            }
        }
    }
});

recentObserver.observe(recentNode, {
    attributes: false,
    childList: true,
    subtree: false,
});


